import  Picto,{pictoProps, pictoState} from "./Picto";
import {connect} from "react-redux";

export interface FiltrePictoProps extends pictoProps {
}

export interface FiltrePictoState extends pictoState {
}

export class FiltrePicto extends Picto<FiltrePictoProps,FiltrePictoState>{
    constructor(props) {
        super(props);
        this.picto = this.props.theme.pictos.filtresPicto;
    }
}

const mapStateToProps = (state) => {
    return {isDark: state.changeTheme.isDark,theme: state.changeTheme.theme};
}

export default connect(mapStateToProps)(FiltrePicto);
